module.exports = __webpack_public_path__ + "static/integrations-a9eb5e2f5028645485f4323e5b2be748.svg";